module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_0.88a13465.png";